import { useMutation } from "react-query";
import { putDataWithDotNet } from "../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { appInsights } from "../../../config/appInsights";
import { message } from "antd";
import { errorHandler } from "../../../helpers/errorHandler";

export type TLockUnlockUserPayload = {
  ssoUserId: string;
  isLocked: boolean;
  reason?: string;
  comment?: string;
};

const lockUnlockAdminUser = async (
  payload: TLockUnlockUserPayload,
): Promise<void> => {
  await putDataWithDotNet(ajaxEndpoints.LOCK_UNLOCK_ADMIN_USER, payload);
};

export function useLockUnlockAdminUser() {
  const [mutate, result] = useMutation(
    (payload: TLockUnlockUserPayload) => lockUnlockAdminUser(payload),
    {
      onSuccess: (_data, variables) => {
        message.success(
          `User has been ${variables.isLocked ? "locked" : "unlocked"} successfully.`,
        );
      },
      onError: (error: any) => {
        appInsights.trackException({
          exception: error,
          properties: { fileName: "useLockUnlockAdminUser.ts" },
        });
        message.error(errorHandler(error));
      },
    },
  );

  return { mutate, result };
}
